import {Image} from './Image';
import {AgeGroup} from './AgeGroup';

/**
 * Data of an over-seasonal team of a club.
 */
export class TeamEventData {
  readonly id: number;
  readonly slug: string;
  readonly clubId: number;
  readonly clubSlug: string;
  readonly names: {
    middle: string;
    full: string;
    short: string;
  };
  readonly level: number;
  readonly image: Image;
  readonly ageGroup: AgeGroup;
}
